<template>
  <span v-html="text"></span>
</template>

<script>
export default {
  name: 'matchedInput',
  props: ['value', 'matches'],
  computed: {
    text() {
      const matchedIndexes = this.matches.reduce((result, item) => {
        result.splice(item.offset, item.length, ...new Array(item.length).fill(true));
        return result;
      }, new Array(this.value.length).fill(false));
      const template = matchedIndexes.reduce((r, value, index) => {
        if (value) {
          if (index === 0) {
            return `${r}<strong>${this.value.charAt(index)}`;
          }
          if (!matchedIndexes[index - 1]) {
            return `${r}<strong>${this.value.charAt(index)}`;
          }
        }
        if (!value && matchedIndexes[index - 1]) {
          return `${r}</strong>${this.value.charAt(index)}`;
        }
        return `${r}${this.value.charAt(index)}`;
      }, '');

      return `${template}</strong>`;
    },
  },
};
</script>